export class VaultProviderAttributes {
    'cloudProvider';
    'aws';
    'azure';
    'gcp';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsVaultConfig",
            "format": ""
        },
        {
            "name": "azure",
            "baseName": "azure",
            "type": "AzureVaultConfig",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpVaultConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VaultProviderAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
